import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import DropFileUploader from '../../components/form/DropFileUploader';
import FormField from '../../components/form/FormField';
import ReduxFormIconPicker from '../../components/reduxFormMUIWrapper/ReduxFormIconPicker';
import ReduxFormSwitch from '../../components/reduxFormMUIWrapper/ReduxFormSwitch';

const useStyles = makeStyles({
  root: {
    composes: 'flexColumn stretch',
  },
});

let PackForm = (props) => {
  const { handleSubmit } = props;
  const classes = useStyles(props);

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <FormField label="Nom" name="name" fullWidth />
      <FormField label="Publié (visible dans l'app)" name="published" component={ReduxFormSwitch} />
      <FormField label="Pack de base (embarqué dans l'app)" name="isBase" component={ReduxFormSwitch} />
      <FormField label="Couverture" name="cover" component={DropFileUploader} fullWidth />
      <FormField label="Icône (à côté du nom dans l'app)" name="icon" component={ReduxFormIconPicker} fullWidth />
      <input type="submit" />
    </form>
  );
};

PackForm.propTypes = {
  onSubmit: PropTypes.func,
};

PackForm = reduxForm({
  form: 'packForm',
  enableReinitialize: true,
})(PackForm);

// creation: no initial values; edition: the pack loaded by editPack
export const PackCreationForm = PackForm;

export const PackEditionForm = connect((state) => {
  const { name, published, isBase, cover, icon } = state.packs.pack || {};
  return { initialValues: { name, published, isBase, cover, icon: icon ?? '' } };
})(PackForm);
